// Lightweight auth hook — stores assessor record in localStorage.
import { useState } from "react";

export function useAuth() {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("drfa_user") || "null");
    } catch {
      return null;
    }
  });
  const save = (u) => {
    localStorage.setItem("drfa_user", JSON.stringify(u));
    setUser(u);
  };
  const clear = () => {
    localStorage.removeItem("drfa_user");
    setUser(null);
  };
  return { user, save, clear };
}
